import React, { PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'

const SECONDARY_DRAWER_PORTAL_ID = 'app-secondary-drawer-root'

export const SecondaryDrawerPortal: React.FC<PropsWithChildren> = ({
  children,
}) => {
  if (typeof document === 'undefined') {
    return <>{children}</>
  }

  const portalTarget = document.getElementById(SECONDARY_DRAWER_PORTAL_ID)
  return portalTarget ? createPortal(children, portalTarget) : <>{children}</>
}
